export const apiSearchProducts = async (params: {
    q: string
    page?: number
    limit?: number
}) => {
if (!process.env.NEXT_PUBLIC_API_URL_SEARCH) {
    console.error('API URL not defined')
    return { data: [], total: 0 }
}
    try {
        
        const res = await fetch(
            `${process.env.NEXT_PUBLIC_API_URL_SEARCH}?q=${encodeURIComponent(params.q)}`,
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                },
                cache: 'no-store',
            },
        )

        if (!res.ok) {
            const text = await res.text()

            console.error('[apiSearchProducts] API error:', res.status, text)

            throw new Error('Ошибка поиска товара')
        }

        return await res.json()
    } catch (error) {
        console.error('Ошибка апи при поиске:', error)
        throw error
    }
}
